import React from 'react'
import { MenuOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import classNames from 'classnames'
import styles from './MobileMenu.module.scss'

interface IMobileMenuProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  Menu: React.ReactElement
}

export const MobileMenu: React.FC<IMobileMenuProps> = React.memo(({ isOpen, setIsOpen, Menu }) => {
  const buttonRef = React.useRef<HTMLButtonElement>(null)
  const modalRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!isOpen) return

    // Кнопку исключаем: иначе её нажатие закрыло бы меню и тут же открыло снова.
    // Подпункты antd рисует в портале за пределами панели — их тоже не считаем «мимо»
    const onPointerDown = (e: PointerEvent) => {
      const target = e.target as Element
      if (
        modalRef.current?.contains(target) ||
        buttonRef.current?.contains(target) ||
        target.closest?.('.ant-menu-submenu-popup')
      ) {
        return
      }
      setIsOpen(false)
    }

    document.addEventListener('pointerdown', onPointerDown)

    return () => document.removeEventListener('pointerdown', onPointerDown)
  }, [isOpen, setIsOpen])

  return (
    <>
      <Button
        ref={buttonRef}
        type='text'
        icon={<MenuOutlined className={styles.button} />}
        onClick={() => setIsOpen(true)}
        className={styles.buttonWrapper}
      />
      <div
        ref={modalRef}
        className={classNames(styles.modalWrapper, {
          [styles.modalWrapperActive]: isOpen
        })}
      >
        {Menu}
      </div>
    </>
  )
})
